import { Routes, Route } from 'react-router-dom';
import HomePage from '../pages/home/HomePage';
import LoginPage from '../pages/login/LoginPage';
import SignUpPage from '../pages/signup/SingUpPage';
import AboutPage from '../pages/about/AboutPage'
import FoundersPage from '../pages/founders/FoundersPage';
import ContactPage from '../pages/contact/ContactPage';
//import ProtectedRoute from '../components/ProtectedRoute';

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/signup" element={<SignUpPage />} />
      <Route path="/about" element={<AboutPage />} />
      <Route path="/founders" element={<FoundersPage />} />
      <Route path="/contact" element={<ContactPage />} />

    </Routes>
  );
};

export default AppRoutes;
